import React, { useState, useEffect, useRef } from 'react';
import { Icon } from './Icon';

const visitOptions = [
  ''
];

const authPersonOptions = [
  ''
];

const areaOptions = [
  ''
];

const pisoOptions = [
  'PB',
  'PISO 1',
  'PISO 2',
  'PISO 3',
  'PISO 4',
  'PISO 5'
];

interface AccessManagementModalProps {
  isVisible: boolean;
  personName: string;
  employeeNo: string;
  status: number;
  onClose: () => void;
  onGenerateAccess: (employeeId: string, visitPerson: string, authPerson: string, areaToVisit: string, pisoToVisit: string,  visitPurpose?: string) => Promise<{ success: boolean, message?: string }>;
  onSave: (state: number | null, employee_id: string | null) => void;
  generating: boolean;
}

interface AutocompleteFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder?: string;
}

const AutocompleteField: React.FC<AutocompleteFieldProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder = ''
}) => {
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const inputRef = useRef<HTMLInputElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (value.trim()) {
      const filtered = options.filter(option =>
        option.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredOptions(filtered);
      setShowDropdown(filtered.length > 0);
      setSelectedIndex(-1);
    } else {
      setFilteredOptions([]);
      setShowDropdown(false);
      setSelectedIndex(-1);
    }
  }, [value, options]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) &&
        inputRef.current && !inputRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
        setSelectedIndex(-1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleOptionSelect = (option: string) => {
    onChange(option);
    setShowDropdown(false);
    setSelectedIndex(-1);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!showDropdown) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev < filteredOptions.length - 1 ? prev + 1 : prev
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => prev > 0 ? prev - 1 : -1);
        break;
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0) {
          handleOptionSelect(filteredOptions[selectedIndex]);
        }
        break;
      case 'Escape':
        setShowDropdown(false);
        setSelectedIndex(-1);
        break;
    }
  };

  

  return (
    <div className="flex-1 relative">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {label}
      </label>
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onFocus={() => {
          if (filteredOptions.length > 0) {
            setShowDropdown(true);
          }
        }}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-800 dark:text-white"
        autoComplete="off"
      />

      {showDropdown && filteredOptions.length > 0 && (
        <div
          ref={dropdownRef}
          className="absolute z-10 w-full mt-1 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg max-h-48 overflow-y-auto"
        >
          {filteredOptions.map((option, index) => (
            <div
              key={option}
              onClick={() => handleOptionSelect(option)}
              className={`px-3 py-2 cursor-pointer transition-colors ${
                index === selectedIndex
                  ? 'bg-blue-500 text-white'
                  : 'hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-900 dark:text-gray-100'
              }`}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const AccessManagementModal: React.FC<AccessManagementModalProps> = ({
  isVisible,
  personName,
  employeeNo,
  status,
  // onGenerateAccess,
  onClose,
  onSave,
  generating
}) => {
  const [visitPerson, setVisitPerson] = useState('');
  const [authPerson, setAuthPerson] = useState('');
  const [areaToVisit, setAreaToVisit] = useState('');
  const [pisoToVisit, setPisoToVisit] = useState('');
  const [visitPurpose, setVisitPurpose] = useState('');

  const handleGenerateAccess = async () => {
    try {
      // if(!visitPerson || !authPerson || !areaToVisit || !pisoToVisit){
      //   alert('Falta llenar algunos campos');
      //   return
      // }

      // const result = await onGenerateAccess(employeeNo, visitPerson, authPerson, areaToVisit, pisoToVisit, visitPurpose); 
      handleSave()

      // if (result.success) {
      //   setVisitPerson('');
      //   setAuthPerson('');
      //   setAreaToVisit('');
      //   setPisoToVisit('');
      //   setVisitPurpose('');
      // } else {
      //   alert(result.message || 'Error al generar el Acceso');
      // }
    } catch (error) {
      console.error('Error generating Acceso:', error);
      alert('Error al generar el Acceso');
    }
  };

  const handleCancel = () => {
    onClose();
    setVisitPerson('');
    setAuthPerson('');
    setAreaToVisit('');
    setVisitPurpose('');
  };

  const handleSave = () => {
    onSave(status, employeeNo);
    onClose(); 
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Gestión de Acceso
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {personName}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-black hover:bg-gray-100 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg transition-colors"
          >
            <Icon name="close" className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
            {/* Primera fila */}
            <div className="flex items-center space-x-4 mb-4">
              <AutocompleteField
                label="A QUIÉN VISITA"
                value={visitPerson}
                onChange={setVisitPerson}
                options={visitOptions}
                placeholder="Buscar persona..."
              />
              <AutocompleteField
                label="QUIÉN AUTORIZA"
                value={authPerson}
                onChange={setAuthPerson}
                options={authPersonOptions}
                placeholder="Buscar autorizador..."
              />
            </div>

            {/* Segunda fila */}
            <div className="flex items-center space-x-4 mb-4">
              <AutocompleteField
                label="ÁREA A LA QUE SE DIRIGE"
                value={areaToVisit}
                onChange={setAreaToVisit}
                options={areaOptions}
                placeholder="Buscar área..."
              />
              <AutocompleteField
                label="PISO"
                value={pisoToVisit}
                onChange={setPisoToVisit}
                options={pisoOptions}
                placeholder="Buscar piso..."
              />
            </div>

            {/* Segunda fila */}
            <div className="flex items-center space-x-4 mb-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  MOTIVO
                </label>
                <input
                  type="text"
                  value={visitPurpose}
                  onChange={(e) => setVisitPurpose(e.target.value)}
                  placeholder="Escribir motivo de la visita..."
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-800 dark:text-white"
                />
              </div>
            </div>

            {/* Botones */}
            <div className="flex items-center justify-end space-x-2">
              <button
                onClick={handleCancel}
                className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
              >
                <Icon name="close" className="w-4 h-4 mr-2" />
                Cancelar
              </button>
              <button
                onClick={handleGenerateAccess}
                disabled={generating}
                className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {generating ? (
                  <Icon name="loading" className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <Icon name="check" className="w-4 h-4 mr-2" />
                )}
                Activar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};